module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block6"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "h17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/TOC"
    }
  }, [_vm._v("Ronin")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p38"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("T")]), _vm._v("he sky above me is deep purple, especially beautiful tonight with the generous dotting of stars. There are no clouds to block the glittering specks of light overhead, and I appreciate the view more than I usually would.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p39"
    }
  }, [_vm._v("Tonight is a celebration of love, something I tend to avoid if I can.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("The crisp North Carolina night hugs the wedding guests as they twirl around the dance floor or congregate at the tables, talking and laughing with one another like they don’t have a care in the world. I spot the members of my team at Night Eagle Security gathered at one table, and my gaze roams over the group as they burst into raucous laughter.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p41"
    }
  }, [_c('i', [_vm._v("They’re enjoying their night. ")]), _vm._v("The thought almost makes me smile.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p42"
    }
  }, [_vm._v("As Jeremy Teague’s best man, I’ve enjoyed myself, too. Watching him fall in love with his high school sweetheart all over again has been fun. He never thought it would happen for him, thought he and Rayne were over a long time ago. When she strolled back into town with their eight-year-old son, Decker, in tow, Jeremy about lost his mind.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p43"
    }
  }, [_vm._v("I was proud of the way he stepped right into that father role like it was easy. Like becoming a parent to a son you previously knew nothing about was a cakewalk. I knew it wasn’t, but for him the choice was clear. He wanted that life with Rayne and Decker.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p44"
    }
  }, [_vm._v("And now he has it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p45"
    }
  }, [_vm._v("My eyes find them, swaying on the dance floor. Rayne’s head rests on Brains’s—the nickname he earned as a gadgets guru on our private security team—shoulder while his hands wander up and down her back. It looks like they move as one unit, and I know that everything will be different now. She’s his number one partner in life now, not me. And that’s how it should be.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p46"
    }
  }, [_vm._v("If I ever thought there was a chance I’d have that opportunity again myself, I’d take it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p47"
    }
  }, [_vm._v("But some people only get that kind of pure, unequaled love once in a lifetime.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p48"
    }
  }, [_vm._v("I’d already had mine.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p49"
    }
  }, [_vm._v("My gaze suddenly sweeps toward the sound of giggling, not far from the newlywed couple. I zero in on a flash of dark red hair pulled to the side, exposing a creamy expanse of graceful neck. Olive Alexander, Rayne’s sister, twirls Decker around in a circle, and then ducks as he does the same for her. They’re both grinning like mad and her dark, blue eyes sparkle in the moonlight. White, glowing paper lanterns all around the yard mingle with the twinkling lights strung from the trees, and the effect it has on Olive takes my fucking breath away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p50"
    }
  }, [_vm._v("I study the pair for a moment. Olive takes both of Decker’s hands as the band launches into a lively tune and the silliness she gives him suits her. I’ve met Olive a handful of times, and even though her beauty always stunned me, I never took her for the laid-back, silly, hands-on-aunt type.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p51"
    }
  }, [_vm._v("Apparently, I’d been wrong.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p52"
    }
  }, [_vm._v("Two deep dimples appear in her cheeks as she drops her head back and laughs at something the kid did, and I find myself lost in a sea of thoughts. "), _c('i', [_vm._v("How often does she ")]), _c('i', [_vm._v("smile like that? When will she be leaving to go back to Europe? Has she always had those goddamn dimples?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p53"
    }
  }, [_vm._v("“She’s pretty.” A soft, matter-of-fact voice reaches me, and I glance to the side and down to see that Sayward Diaz has crept up beside me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p54"
    }
  }, [_vm._v("I’ve only ever seen Sayward in a pair of jeans and sneakers with a hoodie at the Night Eagle office. Tonight, she chose to forgo her usual uniform and wear a simple turquoise dress that sweeps the ground at her feet, showing off the curves she apparently rocked underneath the jeans all this time.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p55"
    }
  }, [_vm._v("“You look good tonight, Diaz.” I catch her eye, making sure she knows I mean it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p56"
    }
  }, [_vm._v("Sayward shrugs. “Thanks. Everyone is supposed to dress up for a wedding, right? I bought this today.” She fingers the soft material of her dress, and I bite back a smile.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p58"
    }
  }, [_vm._v("Social graces aren’t really Sayward’s strong suit. As a consultant for Night Eagle Security, she’s a legit computer hacker whose skills can’t be beat by anyone. But she’s easy to be around, and works her ass off, so I’d never complain about having her around.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p59"
    }
  }, [_vm._v("I raise my bourbon to my lips and sip, appreciating the fiery path it burns down my throat. “Well…you’re rocking the shit outta that dress. Not every woman could.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p60"
    }
  }, [_vm._v("Now her eyes meet mine, like she’s only just figured out that I’m complimenting her. A small smile works its way onto her lips. “Thanks, Swagger.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p61"
    }
  }, [_vm._v("Lifting my chin at her in acknowledgment of my own NES nickname, I indicate the table where our friends are sitting. “Shall we?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p62"
    }
  }, [_vm._v("I hold out my arm, and she looks at it for a second like she’s wondering what to do with it before she finally slips her hand through and lets me lead her toward the table. I pull out a chair for her beside Dare Conners’s wife, Berkeley, and take the empty one opposite Grisham Abbot. His fiancée, Greta, grins at me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p63"
    }
  }, [_vm._v("“You taking all of this in, Ronin?” her sweet voice asks.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p64"
    }
  }, [_vm._v("Shrugging, I down the rest of my drink and contemplate getting back up for a refill. “It was a good wedding.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p65"
    }
  }, [_vm._v("Berkeley leans over Dare to peer at me. “The boys of NES are dropping like flies, Ronin. Don’t tell me you’d never consider settling down again.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p66"
    }
  }, [_vm._v("Dare stares at her. “His nickname is "), _c('i', [_vm._v("Swagger.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p67"
    }
  }, [_vm._v("I roll my eyes. “You know that has nothing to do with women.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p68"
    }
  }, [_vm._v("No, I earned my nickname for the confidence I carry when making a man scream like a crying baby at my mercy. My claim to fame? All the ways I can torture a man without actually killing him. Because in interrogation, the goal is always to make the prisoner talk. If he’s dead, he can’t talk. I have a magic touch in this area. Something I’m proud of? Maybe not. But afterward, I’m able to walk with my head high because what I’ve done furthers the greater good. And that’s something I can live with when my head hits the pillow each night.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p69"
    }
  }, [_vm._v("Grisham, or Ghost as we call his stealthy ass, snorts. “Definitely has nothing to do with women.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p70"
    }
  }, [_vm._v("My team is aware that I already settled down once. It’s just not something we talk about, and that’s my choice. It seems like a lifetime ago, now, but my heart went into the ground at the same time that my wife did.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p71"
    }
  }, [_vm._v("Game over.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p72"
    }
  }, [_vm._v("“I don’t think that whole happily-ever-after shit is for me.” I keep my voice low as I answer Berkeley’s question, averting my gaze.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p73"
    }
  }, [_vm._v("Inside, my chest tightens, the feeling of my heart squeezing dangerously tight overwhelming me. The emotion, the grief and fury that I thought I recovered from a long time ago, resurfaces and threaten to pull me under.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p74"
    }
  }, [_vm._v("Immediately, Berkeley’s whiskey-colored eyes go all soft and gooey and her bottom lip disappears into her mouth. “You don’t know that. Everyone deserves love, Ronin.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p75"
    }
  }, [_vm._v("Shaking my head, I scan the ongoing party. If she thinks I deserve love, it’s because she doesn’t know the truth behind my story. I couldn’t protect my wife the first time around. Pretty sure guys like me don’t get a second shot. And I’ve accepted that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p76"
    }
  }, [_vm._v("I incline my head toward Brains and his brand-new wife, who are now standing beside a small table on the patio. Their faces are masks of utter concentration as they work together to guide a huge knife through a towering white cake. The crowd erupts in cheers when they succeed, and a photographer snaps their picture. I’ve never seen such a look of pure, unadulterated joy on my best friend’s face. There’s a peace about him he never had before.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p77"
    }
  }, [_vm._v("I’m saved from having to answer Berkeley when Decker throws his little body into my side. “Uncle Ronin! You gonna eat cake?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p78"
    }
  }, [_vm._v("Looking at him, I’m pretty sure his cheeks might split open from the size of his smile. The kid just got everything every other child in the world wants. His mom and his dad together under one roof. Holding out my fist, he bumps it and then we blow it up.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p79"
    }
  }, [_vm._v("“Cake? Heck yeah. We gotta have cake.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p80"
    }
  }, [_vm._v("Decker nods, serious as a lethal injection. “Yeah. We gotta have cake.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p81"
    }
  }, [_vm._v("Olive saunters up behind him, leaning low over his shoulder to kiss his cheek. She pauses there, her deep sapphire eyes meeting mine for a brief pause. I take the time to notice for the first time that there’s a dusting of freckles, delicate and sparse, sprinkling her nose and cheeks. That, combined with the dimples, the huge, deep-set eyes, and the striking color of her hair, are enough to keep me locked in her stare.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p82"
    }
  }, [_vm._v("Rising, she doesn’t look away. “Hello, Ronin.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p83"
    }
  }, [_vm._v("Olive’s voice is a lot different from her sister’s. Where Rayne has one of those throaty, sultry voices that screams sex appeal without even trying, Olive’s voice is purer, sweeter. It makes me want to figure out all the ways I can dirty her up. I stand, holding Decker by the shoulders, and face her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p84"
    }
  }, [_vm._v("“Hey. Jeremy told me you’d be here for the wedding. How long you in town for?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p85"
    }
  }, [_vm._v("Her eyes go cloudy, and I zero in on her expression because something in it falters before she wraps it up tight and offers a strained smile. “Oh, um…I finished with the job in Paris a couple months ahead of schedule. My, uh, client…died. So, yeah. I’m back in Wilmington working out of our office here.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p86"
    }
  }, [_vm._v("I know that Olive is an interior designer, and that the firm she works for has international clients. It’s how she and Berkeley met, and how Rayne ended up working at Night Eagle when she arrived back in town. Beyond that, I don’t know much of anything about Olive. There’s something eating at her now, though. That much is obvious.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p87"
    }
  }, [_vm._v("“I see.” I nod, holding her gaze once more. But before I can get a read on her, she glances down at Decker.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p88"
    }
  }, [_vm._v("“Ready for cake?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p89"
    }
  }, [_vm._v("He pumps his head up and down, turning toward me. “Let’s go, Uncle Ronin.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p90"
    }
  }, [_vm._v("Olive lifts her brows, her expression surprised. “He calls you Uncle Ronin?” she asks as we follow the little boy toward the patio.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p91"
    }
  }, [_vm._v("I chuckle, rubbing the back of my neck with a hand. “Yeah. Brains’s fault. I don’t mind, though.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p92"
    }
  }, [_vm._v("She frowns. “Brains?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p93"
    }
  }, [_vm._v("I smile down at her. The muscles it takes to do so feel unused, rusty. I’ve smiled at plenty of women before, just not women who affect me the way Olive seems to. “Nickname. We all have one.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p94"
    }
  }, [_vm._v("She nods, understanding dawning across her face. “It’s a military thing.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p96"
    }
  }, [_vm._v("Walking onto the patio, Decker rushes straight into Rayne’s arms, and Jeremy edges toward me. We both watch as Decker stands between Rayne and Olive, both women showering the eight-year-old with loving attention. When Olive brushes a lock of his hair off his forehead, my chest pulls tight.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p97"
    }
  }, [_c('i', [_vm._v("The fuck? ")]), _vm._v("It’s the sentimentality of this day, drawing me in and fucking with my head. That’s all it can be.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p98"
    }
  }, [_vm._v("“I’m a lucky bastard.” Jeremy folds his arms, and when I glance at him, his eyes are locked on his family.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p99"
    }
  }, [_vm._v("The family he never even knew he needed but is now willing to die to protect.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p100"
    }
  }, [_vm._v("I watch them, too. My eyes keep straying to Olive, who looks so comfortable with Decker.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p101"
    }
  }, [_vm._v("“You talked to her tonight?” Jeremy asks suddenly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p102"
    }
  }, [_vm._v("Glancing away from Olive, I find that he’s staring directly at me. “Who? Olive?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p103"
    }
  }, [_vm._v("He nods, studying me. “Yeah.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p104"
    }
  }, [_vm._v("Shaking my head, I look back at the two women and Decker. “Not really. Why?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p105"
    }
  }, [_vm._v("He turns away from the women, and I follow suit. Walking a few feet from the patio, he starts talking. “I don’t know, man. She got into town last night. I picked her up from the airport, and she was…off. I mean, I don’t know her that well. But she seems worried.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p106"
    }
  }, [_vm._v("The protective instinct inside of me, the one that’s lain dormant now for exactly seven years, lifts its head. “You ask her?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p107"
    }
  }, [_vm._v("He shakes his head slowly. “Didn’t know how to. I mean, we knew each other back in high school because of Rayne, but we weren’t close. And we certainly aren’t best friends now. But she’s my sister-in-law, and she means a lot to Rayne. I want to know what’s going on with her. But I don’t think she’d tell me if I asked.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p108"
    }
  }, [_vm._v("“Why do you say that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p109"
    }
  }, [_vm._v("He runs a hand through his long hair. “Olive is…capable. She likes to do everything herself. She likes to be in control. At least that’s how Rayne tells it. I doubt she would respond well if she thought I was stepping in where I don’t belong, or trying to help her when she thinks she’s got it handled.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p110"
    }
  }, [_vm._v("I nod. I get that. Every vibe I’ve ever gotten off of Olive tells me she’s independent as fuck. She’s always well put-together, she drives a nice car, she owns her own house. And she has a successful career. So if she were in trouble, she wouldn’t necessarily ask for help.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p111"
    }
  }, [_vm._v("“What do you need?” My tone cautious, I wait for Jeremy to roll out whatever it is he’s asking.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p112"
    }
  }, [_vm._v("“Rayne and Decker and I are going to Aruba for a couple of weeks. You know that. I just want you to keep an eye on her, Swagger. Make sure she’s okay. Shit, make plans with her if you have to. I just need to know that you’ll be there if she needs you. Obviously if need be, we can be on the first flight back to Wilmington. ”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p113"
    }
  }, [_vm._v("I understood. Jeremy’s all about family now that he has one, and he wants to protect Olive as a part of that family. As his best friend, I’m the first person he’d ask to make sure she’s okay while he’s away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p114"
    }
  }, [_vm._v("My eyes straying back to Olive as she takes a delicate bite of cake, I feel that the protective instinct inside of me is now fully awake. Even if Olive wants me nowhere near whatever problem she might be having, I’ll be there. I’ll step in whether she wants me to or not.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p115"
    }
  }, [_vm._v("When her eyes meet mine, her fork freezes halfway to her mouth with her second bite and a strong current of something I can’t understand pulls taut between us. When the cake finally makes it to her mouth, I watch, fascinated, as she chews. Then she swallows, her slender throat moving with the action. Her tongue darts out to lick the stray pieces of sugar from her lips and my dick stirs in my pants. I want to lick those plump lips. And where the hell does that desire come from?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p116"
    }
  }, [_vm._v("Maybe getting to the bottom of whatever is bothering Olive Alexander won’t be work, or just a favor for my best friend.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p117"
    }
  }, [_vm._v("Maybe it’ll be "), _c('i', [_vm._v("fun")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fa94c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s005-Chapter-001.vue
// module id = 72
// module chunks = 0